exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mentions_container__2YuUY .ant-mentions textarea{resize:vertical;min-height:8rem}", ""]);

// Exports
exports.locals = {
	"container": "mentions_container__2YuUY"
};